import React from 'react';
export var useBlockScroll = function useBlockScroll(active, container) {
  var node = React.useRef(null);
  React.useEffect(function () {
    node.current = container !== null && container !== void 0 ? container : window.document.body;
  }, []);
  React.useEffect(function () {
    var element = node.current;
    if (element) {
      var prevOverflow = element.style.overflow;
      if (active) {
        element.style.overflow = 'hidden';
      }
      return function () {
        element.style.overflow = prevOverflow;
      };
    }
    return undefined;
  }, [active]);
};